var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconCelebration40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2275_8957)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6108 14.3183V10.4755",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 14.3183V10.4755",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3896 14.3183V10.4755",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6119 7.40137C14.2231 8.07021 14.5846 8.57974 14.6963 8.92995C14.8638 9.45527 14.7165 9.90705 14.2821 10.2286C13.8476 10.5502 13.3971 10.5656 12.9417 10.2286C12.4863 9.89157 12.363 9.44556 12.5275 8.92995C12.6371 8.58621 12.9986 8.07668 13.6119 7.40137Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0011 7.40125C20.6123 8.07009 20.9737 8.57962 21.0854 8.92983C21.253 9.45514 21.1057 9.90693 20.6712 10.2285C20.2368 10.55 19.7862 10.5655 19.3309 10.2285C18.8755 9.89144 18.7522 9.44544 18.9167 8.92983C19.0263 8.58609 19.3878 8.07656 20.0011 7.40125Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3907 7.40137C27.0019 8.07021 27.3634 8.57974 27.4751 8.92995C27.6426 9.45527 27.4953 9.90705 27.0609 10.2286C26.6265 10.5502 26.1759 10.5656 25.7205 10.2286C25.2651 9.89157 25.1419 9.44556 25.3063 8.92995C25.4159 8.58621 25.7774 8.07668 26.3907 7.40137Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5503 13.9341H33.4499C34.2988 13.9341 34.987 14.6223 34.987 15.4712V32.3795C34.987 33.2284 34.2988 33.9166 33.4499 33.9166H6.5503C5.70138 33.9166 5.01318 33.2284 5.01318 32.3795V15.4712C5.01318 14.6223 5.70138 13.9341 6.5503 13.9341Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5503 13.9341H33.4499C34.2988 13.9341 34.987 14.6223 34.987 15.4712V20.8511H5.01318V15.4712C5.01318 14.6223 5.70138 13.9341 6.5503 13.9341Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2275_8957"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.502686)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconCelebration40);
export default __webpack_public_path__ + "static/media/pictogramBeaconCelebration40.9032863544d27cbc1336304411e8d107.svg";
export { ForwardRef as ReactComponent };